import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskExternalLinksRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-external-links',
	path: '/jira/servicedesk/projects/:projectKey/settings/external-links',
	exact: true,
};
